'use strict';
import { BaseFilter } from './base-filter';
import template from './date-filter.html';

export class DateFilter extends BaseFilter {
	constructor(options) {
		super(options);

		this.type = 'date';
		this.panelTemplate = template;
		this.operators = [this.allOperators.Between];
	}

	getNewValue() {
		return [(this.dateFrom && this.dateFrom.toISOString()) || '', (this.dateTo && this.dateTo.toISOString()) || ''];
	}

	updateTitle() {
		this.title =
			(this.dateFrom ? this.i18n.get('components.common.dateFrom') + ': ' + this.i18n.formatDate(this.dateFrom, this._column.Format) + '; ' : '') +
			(this.dateTo ? this.i18n.get('components.common.dateTo') + ': ' + this.i18n.formatDate(this.dateTo, this._column.Format) : '');
	}

	setDefault() {
		this.dateFrom = null;
		this.dateTo = null;
	}

	hasValue() {
		return Boolean(this.value && (this.value[0] || this.value[1]));
	}
}
